import {
  GET_AUTHORIZATIONS_PENDING_FAILURE, GET_AUTHORIZATIONS_PENDING_REQUEST, GET_AUTHORIZATIONS_PENDING_SUCCESS,
  GET_AUTHORIZATIONS_SUBMITTED_FAILURE, GET_AUTHORIZATIONS_SUBMITTED_REQUEST, GET_AUTHORIZATIONS_SUBMITTED_SUCCESS,
  GET_AUTHORIZATION_CURRENT_PREVIOUS_FAILURE, GET_AUTHORIZATION_CURRENT_PREVIOUS_REQUEST, GET_AUTHORIZATION_CURRENT_PREVIOUS_SUCCESS,
  GET_AUTHORIZATION_SEARCH_RESULTS_FAILURE, GET_AUTHORIZATION_SEARCH_RESULTS_REQUEST, GET_AUTHORIZATION_SEARCH_RESULTS_SUCCESS,
  GET_AUTHS_BY_STATE_FAILURE, GET_AUTHS_BY_STATE_REQUEST, GET_AUTHS_BY_STATE_SUCCESS,
  GET_BLOG_DATA_FAILURE, GET_BLOG_DATA_REQUEST, GET_BLOG_DATA_SUCCESS,
  GET_CLIENT_CONTACT_FAILURE, GET_CLIENT_CONTACT_REQUEST, GET_CLIENT_CONTACT_SUCCESS,
  GET_EXCEPTIONS_CURRENT_PREVIOUS_FAILURE, GET_EXCEPTIONS_CURRENT_PREVIOUS_REQUEST, GET_EXCEPTIONS_CURRENT_PREVIOUS_SUCCESS,
  GET_EXPENSES_CURRENT_PREVIOUS_FAILURE, GET_EXPENSES_CURRENT_PREVIOUS_REQUEST, GET_EXPENSES_CURRENT_PREVIOUS_SUCCESS,
  GET_HOMESALE_STATUS_DATA_FAILURE, GET_HOMESALE_STATUS_DATA_REQUEST, GET_HOMESALE_STATUS_DATA_SUCCESS,
  GET_STATES_FAILURE, GET_STATES_REQUEST, GET_STATES_SUCCESS,
  GET_SURVEY_CURRENT_PREVIOUS_FAILURE, GET_SURVEY_CURRENT_PREVIOUS_REQUEST, GET_SURVEY_CURRENT_PREVIOUS_SUCCESS,
  GET_ALL_PROVINCES_REQUEST, GET_ALL_PROVINCES_SUCCESS, GET_ALL_PROVINCES_FAILURE,
  GET_ALL_COUNTRIES_REQUEST, GET_ALL_COUNTRIES_SUCCESS, GET_ALL_COUNTRIES_FAILURE,
} from './dashboard.actions';
import { sortCountries, sortProvinces } from '../../utilities/enumSorting';
import Immutable from 'immutable';
import US_STATES from '../../utilities/usStates';

const initialState = Immutable.Map({
  blog: {
    blogLoading: false,
    blogFeed: {},
    blogError: false,
  },
  activeAuthFiles: [],
  authPending: 0,
  authSubmitted: 0,
  authorizationsYTD: { CurrentYear: 0, PreviousYear: 0 },
  exceptions: { CurrentYear: 0, PreviousYear: 0 },
  expenses: { CurrentYear: 0, PreviousYear: 0 },
  surveyScore: { CurrentYear: 0, PreviousYear: 0 },
  clientContact: null,
  isLoading: false,
  provinceEnums: [],
  countries: [],
});

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_BLOG_DATA_REQUEST:
      return state.set('blogLoading', true);

    case GET_BLOG_DATA_SUCCESS:
      return state.set('blogLoading', false)
        .set('blogFeed', action.payload)
        .set('blogError', false);

    case GET_BLOG_DATA_FAILURE:
      return state.set('blogLoading', false)
        .set('blogError', true);
    case GET_AUTHORIZATION_CURRENT_PREVIOUS_REQUEST:
      return state.set('isLoading', true);

    case GET_AUTHORIZATION_CURRENT_PREVIOUS_SUCCESS:
      // V2 API returns { currentYear, previousYear } or { CurrentYear, PreviousYear }
      // StatsCards expects object with PascalCase: { CurrentYear, PreviousYear }
      return state
        .set('authorizationsYTD', {
          CurrentYear: action.response?.currentYear ?? action.response?.CurrentYear ?? 0,
          PreviousYear: action.response?.previousYear ?? action.response?.PreviousYear ?? 0,
        })
        .set('isLoading', false);

    case GET_AUTHORIZATION_CURRENT_PREVIOUS_FAILURE:
      return state.set('isLoading', false);

    case GET_EXPENSES_CURRENT_PREVIOUS_REQUEST:
      return state.set('isLoading', true);

    case GET_EXPENSES_CURRENT_PREVIOUS_SUCCESS:
      // V2 API returns { currentYear, previousYear } or { CurrentYear, PreviousYear }
      // StatsCards expects object with PascalCase: { CurrentYear, PreviousYear }
      return state
        .set('expenses', {
          CurrentYear: action.response?.currentYear ?? action.response?.CurrentYear ?? 0,
          PreviousYear: action.response?.previousYear ?? action.response?.PreviousYear ?? 0,
        })
        .set('isLoading', false);

    case GET_EXPENSES_CURRENT_PREVIOUS_FAILURE:
      return state.set('isLoading', false);

    case GET_EXCEPTIONS_CURRENT_PREVIOUS_REQUEST:
      return state.set('isLoading', true);

    case GET_EXCEPTIONS_CURRENT_PREVIOUS_SUCCESS:
      // V2 API returns { currentYear, previousYear } or { CurrentYear, PreviousYear }
      // StatsCards expects object with PascalCase: { CurrentYear, PreviousYear }
      return state
        .set('exceptions', {
          CurrentYear: action.response?.currentYear ?? action.response?.CurrentYear ?? 0,
          PreviousYear: action.response?.previousYear ?? action.response?.PreviousYear ?? 0,
        })
        .set('isLoading', false);

    case GET_EXCEPTIONS_CURRENT_PREVIOUS_FAILURE:
      return state.set('isLoading', false);

    case GET_AUTHORIZATION_SEARCH_RESULTS_REQUEST:
      return state.set('isLoading', true);

    case GET_AUTHORIZATION_SEARCH_RESULTS_SUCCESS:
      // V2 API may return camelCase or PascalCase properties
      // Transform to expected property names (some components use different casing)
      const transformedAuthFiles = (action.response || []).map((item) => ({
        ...item,
        // Map to expected property names (handle both casing)
        AuthorizationID: item.authorizationId ?? item.AuthorizationId,
        EmployeeId: item.employeeId ?? item.EmployeeId,
        FirstName: item.firstName ?? item.FirstName,
        LastName: item.lastName ?? item.LastName,
        InitiationDate: item.initiationDate ?? item.InitiationDate,
        NewJobStartDate: item.newJobStartDate ?? item.NewJobStartDate,
        OldCity: item.oldCity ?? item.OldCity,
        NewCity: item.newCity ?? item.NewCity,
        OldCountry: item.oldCountry ?? item.OldCountry,
        NewCountry: item.newCountry ?? item.NewCountry,
        OldState: item.oldState ?? item.OldState,
        NewState: item.newState ?? item.NewState,
        VIP: item.vip ?? item.Vip,
        Status: item.status ?? item.Status,
        ReloPolicy: item.reloPolicy ?? item.ReloPolicy,
        DestWorkCity: item.destWorkCity ?? item.DestWorkCity,
        DestWorkOfficeState: item.destWorkOfficeState ?? item.DestWorkOfficeState,
      }));
      return state
        .set('activeAuthFiles', transformedAuthFiles.filter((item) => item.Status === 'Active' || item.Status === 'Extended Service' || item.Status === 'Init' || item.Status === 'On Hold' || item.Status === 'Ops Closed' || item.Status === 'On Assignment' || item.Status === 'PENDING'))
        .set('isLoading', false);

    case GET_AUTHORIZATION_SEARCH_RESULTS_FAILURE:
      return state.set('isLoading', false);

    case GET_AUTHORIZATIONS_PENDING_REQUEST:
      return state.set('isLoading', true);

    case GET_AUTHORIZATIONS_PENDING_SUCCESS:
      return state
        .set('authPending', action.response.length)
        .set('isLoading', false);

    case GET_AUTHORIZATIONS_PENDING_FAILURE:
      return state.set('isLoading', false);

    case GET_AUTHORIZATIONS_SUBMITTED_REQUEST:
      return state.set('isLoading', true);

    case GET_AUTHORIZATIONS_SUBMITTED_SUCCESS:
      return state
        .set('authSubmitted', action.response.length)
        .set('isLoading', false);

    case GET_AUTHORIZATIONS_SUBMITTED_FAILURE:
      return state.set('isLoading', false);

    case GET_CLIENT_CONTACT_REQUEST:
      return state.set('isLoading', true);

    case GET_CLIENT_CONTACT_SUCCESS:
      // Take first contact from array (since we're now fetching all contacts via old API)
      // Old API returns array, so take first element
      const contact = Array.isArray(action.response) && action.response.length > 0 
        ? action.response[0] 
        : action.response;
      const transformedContact = contact ? {
        UserName: contact.userName ?? contact.UserName,
        EmailAddress: contact.emailAddress ?? contact.EmailAddress,
        FirstName: contact.firstName ?? contact.FirstName,
        LastName: contact.lastName ?? contact.LastName,
        Title: contact.title ?? contact.Title,
        OfficePhone: contact.officePhone ?? contact.OfficePhone,
        HoptreeNumber: contact.hoptreeNumber ?? contact.HoptreeNumber,
        Photo: contact.photo ?? contact.Photo,
        TypeOfPhoto: contact.typeOfPhoto ?? contact.TypeOfPhoto,
        CalendlyUrl: contact.calendlyUrl ?? contact.CalendlyUrl,
      } : null;
      return state
        .set('clientContact', transformedContact)
        .set('isLoading', false);

    case GET_CLIENT_CONTACT_FAILURE:
      return state.set('isLoading', false);

    case GET_SURVEY_CURRENT_PREVIOUS_REQUEST:
      return state.set('isLoading', true);

    case GET_SURVEY_CURRENT_PREVIOUS_SUCCESS:
      // V2 API returns { currentYear, previousYear } or { CurrentYear, PreviousYear }
      // StatsCards expects object with PascalCase: { CurrentYear, PreviousYear }
      return state
        .set('surveyScore', {
          CurrentYear: action.response?.currentYear ?? action.response?.CurrentYear ?? 0,
          PreviousYear: action.response?.previousYear ?? action.response?.PreviousYear ?? 0,
        })
        .set('isLoading', false);

    case GET_SURVEY_CURRENT_PREVIOUS_FAILURE:
      return state.set('isLoading', false);

    case GET_AUTHS_BY_STATE_REQUEST:
      return state.set('authsByStateLoading', true);

    case GET_AUTHS_BY_STATE_SUCCESS:
      // Transform V2 API response to expected format for heatMap
      // V2 may return camelCase or PascalCase: { currentYear/CurrentYear, previousYear/PreviousYear, stateName/StateName, stateCode/StateCode }
      // Expected: { YTDCount, RollingCount, State, StateName, Country }
      // StateName is used for better province matching (e.g., "California" vs "CA")
      const transformedAuthData = (action.response || []).map((item) => ({
        YTDCount: item.currentYear ?? item.CurrentYear ?? 0,
        RollingCount: item.previousYear ?? item.PreviousYear ?? 0,
        State: (item.stateCode ?? item.StateCode ?? '').toUpperCase(),
        StateName: item.stateName ?? item.StateName ?? '',
        Country: null, // Will be determined from provinces in HeatMap
      }));
      return state
        .set('authorizationsByState', transformedAuthData)
        .set('authsByStateLoading', false);

    case GET_AUTHS_BY_STATE_FAILURE:
      return state.set('authsByStateLoading', false);

    case GET_HOMESALE_STATUS_DATA_REQUEST:
      return state.set('isLoading', true);

    case GET_HOMESALE_STATUS_DATA_SUCCESS:
      // V2 API may return { status, count } or { Status, Count }
      // Transform to { Status, Count } for HomeSaleChart component
      const transformedHomesaleData = (action.response || []).map((item) => ({
        Status: item.status ?? item.Status,
        Count: item.count ?? item.Count,
      }));
      return state
        .set('homesaleData', transformedHomesaleData)
        .set('isLoading', false);

    case GET_HOMESALE_STATUS_DATA_FAILURE:
      return state.set('isLoading', false);

    case GET_STATES_REQUEST:
      return state.set('isLoading', true);

    case GET_STATES_SUCCESS:
      return state.set('states', action.response).set('isLoading', false);

    case GET_STATES_FAILURE:
      return state.set('isLoading', false);

    case GET_ALL_PROVINCES_REQUEST:
      return state.set('isLoading', true);

    case GET_ALL_PROVINCES_SUCCESS:
      // Transform V2 provinces to expected format
      // V2 may return camelCase or PascalCase: { id/Id, title/Title, isActive/IsActive, countryId/CountryId, code/Code }
      // Expected: { CountryCode, Code, Description }
      // V2 provinces endpoint returns ALL provinces globally - map countryId to CountryCode using countries
      const countries = state.get('countries') || [];
      const countryMap = {};
      countries.forEach((c) => {
        countryMap[c.Id] = c.CountryCode;
      });
      
      const usProvinces = sortProvinces(action.response || [])
        .filter((p) => (p.isActive ?? p.IsActive))
        .map((p) => {
          const provinceCountryId = p.countryId ?? p.CountryId;
          const countryCode = countryMap[provinceCountryId] || 'USA'; // Fallback to USA if no match
          return {
            CountryCode: countryCode,
            Code: (p.code ?? p.Code ?? '').toUpperCase(),
            Description: p.title ?? p.Title,
          };
        });
      // Fallback to hardcoded US_STATES if V2 returns no provinces
      const allProvinces = usProvinces.length > 0 ? usProvinces : US_STATES.map((s) => ({
        CountryCode: 'USA',
        Code: s.Code,
        Description: s.Description,
      }));
      return state.set('provinceEnums', allProvinces).set('isLoading', false);

    case GET_ALL_PROVINCES_FAILURE:
      // Fallback to hardcoded US_STATES if API fails
      const fallbackProvinces = US_STATES.map((s) => ({
        CountryCode: 'USA',
        Code: s.Code,
        Description: s.Description,
      }));
      return state.set('provinceEnums', fallbackProvinces).set('isLoading', false);

    case GET_ALL_COUNTRIES_REQUEST:
      return state.set('isLoading', true);

    case GET_ALL_COUNTRIES_SUCCESS:
      // Store countries for reference
      // V2 returns: { id, title, isActive, countryCode, isoCode2, isoNumeric, defaultCurrencyId }
      const allCountries = sortCountries(action.response || []).map((c) => ({
        Id: c.id ?? c.Id,
        Title: c.title ?? c.Title,
        CountryCode: c.countryCode ?? c.CountryCode,
        ISOCode2: c.isoCode2 ?? c.ISOCode2,
      }));
      return state.set('countries', allCountries).set('isLoading', false);

    case GET_ALL_COUNTRIES_FAILURE:
      return state.set('isLoading', false);

    default:
      return state;
  }
}
